import { ResourceType, getResourcePathSegments, IResourcePathSegments } from 'app/apis/azure-resource.constants';
import { IArmTemplate, IArmTemplateResource, IDependency, resourceIdSyntax } from 'app/interfaces/IArmTemplate';
import { Dictionary } from 'lodash';
import { format } from 'app/shared/utils/string.util';

export interface IPublishableResource {
    identity: string;
    resourceName: string;
    resourceType: string;
    resourceProperties: IArmTemplateProperties;
    dependencies: IDependency[];
}

export interface IArmTemplateProperties {
    // eslint-disable-next-line
    type: string;
    typeProperties: Dictionary<{}>;
    tags: {};
}

export class ResourcePublisherUtils {
    public static getDeploymentResource(name: string, templateChunkIndex: number, template: IArmTemplate, factoryName: string): IArmTemplateResource {
        const resourcePathSegments = getResourcePathSegments(ResourceType.Deployment);
        const deploymentType = this._getResourceTypeString(resourcePathSegments);
        const armTemplateProp: IArmTemplateProperties = {
            type: deploymentType,
            typeProperties: {
                properties: {
                    mode: 'incremental',
                    templateLink: {
                        uri: `[concat(parameters('containerUri'), '/${name}_${templateChunkIndex}.json', parameters('containerSasToken'))]`,
                        contentVersion: '1.0.0.0'
                    },
                    parameters: template.parameters
                }
            },
            tags: {}
        };
        const dependencies: IDependency[] = [];

        // sync linked template processing
        if (templateChunkIndex > 0) {
            dependencies.push(
            {
                conceptType: deploymentType,
                resourceName: `${factoryName}_${name}_${templateChunkIndex - 1}`
            });
        }

        return this._getResource(this._getPublishableResource(`${factoryName}_${name}_${templateChunkIndex}`, armTemplateProp, deploymentType, resourcePathSegments.apiVersion, dependencies));
    }

    private static _getResourceTypeString(resourcePathSegments: IResourcePathSegments): string {
        let resourceTypeString = resourcePathSegments.providerNamespace;
        if (resourcePathSegments.parentResourceType) {
            resourceTypeString += `/${resourcePathSegments.parentResourceType}`;
        }
        resourceTypeString += `/${resourcePathSegments.resourceType}`;
        return resourceTypeString;
    }

    private static _getPublishableResource(
        resName: string,
        resProperties: IArmTemplateProperties,
        resType: string,
        apiVersion: string,
        dependencies?: IDependency[]): IPublishableResource {
        resProperties.typeProperties.apiVersion = apiVersion;
        const resource: IPublishableResource = {
            // TODO - ans - Remove Identity from the resource.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            identity: resType!,
            resourceName: resName,
            resourceProperties: resProperties,
            resourceType: resType,
            dependencies: dependencies ? dependencies : []
        };
        return resource;
    }

    private static _getResource(publishableResource: IPublishableResource): IArmTemplateResource {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const resource: any = {
            name: publishableResource.resourceName,
            type: publishableResource.resourceType,
            apiVersion: publishableResource.resourceProperties.typeProperties.apiVersion,
            properties: {},
            dependsOn: this._getDependencies(publishableResource.dependencies)
        };
        for (const property in publishableResource.resourceProperties.typeProperties) {
            resource[property] = publishableResource.resourceProperties.typeProperties[property];
        }
        return resource;
    }

    private static _getDependencies(dependencies: IDependency[]): string[] {
        const decoratedDependencies = [];
        for (const dependency of dependencies) {
            const dependencyName = `[${format(resourceIdSyntax, `'${dependency.conceptType}'`, `'${dependency.resourceName}'`)}]`;
            decoratedDependencies.push(dependencyName);
        }
        return decoratedDependencies;
    }
}
